import React from 'react'
import { Grid, Box, Container, Link, Typography } from '@mui/material'
import ZendeskLink from 'components/Common/ZendeskLink'
import './index.css'
// import BusinessCount from './BusinessCount'
// import BlogsComponent from './Blogs'
import FollowedBusiness from 'components/MyBusiness/FollowedBusiness'

import SearchBar from './SearchBar'
import SearchResults from './SearchResults'
import { useSelector, useDispatch } from 'react-redux'
import { fetchMonitoredBusiness } from 'store/actions/businessListingActions'
// import IdleTimer from 'components/Common/IdleTimer'
import MainLayout from 'layouts/mainLayout'
import PoweredByEquifax from 'components/Common/PoweredByEquifax'

const FindPage = () => {
  const businessReducer = useSelector(state => state.businessReducer)
  const dispatch = useDispatch()
  React.useEffect(() => {
    fetchMonitoredBusiness(dispatch)
  }, [dispatch])

  return (
    <MainLayout>
      <Box>
        {/* <IdleTimer maxIdleTime={process.env['REACT_APP_MAX_IDLE_TIME_DASHBOARD']} /> */}
        <Container className="my-4">
          {/* <Grid container spacing={2} style={{ minHeight: '580px' }}> */}
          <Grid container spacing={2}>
            <Grid item xs={12} className="px-5 pt-5 pb-2">
              <Typography variant="h4" color="#25245f" marginBottom="30px" fontFamily="poppins">
                Find a Business
              </Typography>
              <SearchBar />
              {businessReducer.searchList || businessReducer.showSpinner ? (
                <SearchResults />
              ) : (
                <>
                  <FollowedBusiness />
                  {/* <BusinessCount /> */}
                  {/* <BlogsComponent /> */}
                </>
              )}
            </Grid>
          </Grid>
        </Container>
        <Box display="flex" padding="0px 40px 0px 40px" borderTop="1px solid #CEE4F5" justifyContent="space-between">
          <PoweredByEquifax />
          <ZendeskLink />
        </Box>
        {(businessReducer.searchList || businessReducer.showSpinner) && (
          <Link
            marginLeft="40px"
            target="_blank"
            href="https://clearbit.com/"
            color="#0373C9"
            fontWeight={700}
            underline="hover"
            fontStyle="normal"
            fontSize="12px"
          >
            Logos provided by Clearbit
          </Link>
        )}
        {(businessReducer.searchList || businessReducer.showSpinner) && (
          <Typography style={{ visibility: 'hidden' }} variant="body2">
            Hidden Text
          </Typography>
        )}
      </Box>
    </MainLayout>
  )
}

export default FindPage
